import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ApplicationResponse } from "@src/common/domain/common.model";
import api from "@src/common/services/api.service";
import AppConstants from "@src/utils/app.constants";
import React from "react";
import { NewUserGroupsModelRef, UserGroupsStore } from "../domain/user.model";
export const addusersGroupList = createAsyncThunk<void, any>("usersGroups/addusersGroup",
 async (payload: any) => {

    const response = await api.post<ApplicationResponse<NewUserGroupsModelRef[]>>(`${AppConstants.api}/usergroup/create`, payload)
});
export const updateUserGroup = createAsyncThunk<void, { id: string; data: any }>(
  "users/updateUserGroup",
  async ({ id, data }) => {
    try {
      const response = await api.put<ApplicationResponse<any>>(
        `${AppConstants.api}/usergroup?id=${id}`,
        data
      );


      return; 
    } catch (error) {
      // return rejectWithValue(error.response?.data || error.message);
    }
  }
);
export const deleteUserGroup = createAsyncThunk(
  "users/deleteUser",
  async (id: string) => {
    try {
      const response = await api.delete<ApplicationResponse<any[]>>(
        `${AppConstants.api}/usergroup?id=${id}`
      );
      return response.data.data || [];
    } catch (err) {
      return [];
    }
  }
);
export const fetchUserGroupsList = createAsyncThunk<any[], void>(
  "userGroups/fetchUserGroups",
  async () => {
    const response = await api.get<ApplicationResponse<NewUserGroupsModelRef[]>>(`${AppConstants.api}/usergroup/list`,
   
  )
        return response.data.data || []
  }
);

const userGroupsSlice = createSlice({
  name: "userGroups",
  initialState: {
    minimal: { status: "loading", error: null, data: [] },
  } as UserGroupsStore,
  reducers: {
 
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUserGroupsList.pending, (state, action) => {
        state.minimal = {
          status: "loading",
          data: [],
          error: null,
        };
      })
      .addCase(fetchUserGroupsList.fulfilled, (state, action) => {
        state.minimal = {
          status: "idle",
          data: action.payload,
          error: null,
        };
      })
      .addCase(fetchUserGroupsList.rejected, (state, action) => {
        state.minimal = {
          status: "failed",
          data: [],
          error: action.error,
        };
      });
  },
});

export default userGroupsSlice.reducer;
